<template>
    <div class="sign-in-content">
        <div class="form-position-wrapper">
            <div v-if="!errorMsg" class="signing-in-text">
                {{ $t('sign-in.signing-in-text') }}
            </div>
            <div v-show="showLoadingSpinner" class="spinner"></div>
            <div v-if="errorMsg" class="error error-message">
                {{ errorMsg }}
            </div>
            <router-link v-if="errorMsg" :to="{ name: 'SignIn' }">
                {{ $t('email-sign-in.sign-in-again') }}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailSignIn',
    components: {},
    inject: ['authService'],
    data() {
        return {
            showLoadingSpinner: false,
            errorMsg: null,
            email: null,
            otc: null
        };
    },
    mounted() {
        this.email = this.$route.query.email;
        this.otc = this.$route.query.otc;

        if (!this.email || !this.otc) {
            this.showErrorMessage();
        } else {
            this.showLoadingSpinner = true;
            this.errorMessage = '';

            this.authService
                .verifyOtcCode(this.email, this.otc, true)
                .then(() =>
                    this.$router.push({
                        name: 'SignIn'
                    })
                )
                .catch(this.showErrorMessage.bind(this))
                .finally(() => this.showLoadingSpinner = false);
        }
    },
    methods: {
        handleSignInErrorResponse(error) {
            this.showErrorMessage(error);
        },
        showErrorMessage() {
            this.errorMsg = this.$t('email-sign-in.invalid-link');
        }
    }
};
</script>

<style scoped lang="scss">
.sign-in-content {
    max-width: 400px;
    margin: auto;

    .error-message {
        position: relative;
        width: 100%;
        margin-top: 0;
    }

    .form-position-wrapper {
        .spinner {
            top: 0;
            left: 0;
        }
    }

    a {
        float: right;
        margin-top: 2em;
    }
}
</style>
